module.exports = __webpack_public_path__ + "img/AndrewTess_140x140_rund.4dd0fbbd.jpg";